import { render } from "./Setting_v.vue?vue&type=template&id=017a872d&scoped=true"
import script from "./Setting_v.vue?vue&type=script&lang=js"
export * from "./Setting_v.vue?vue&type=script&lang=js"

import "./Setting_v.vue?vue&type=style&index=0&id=017a872d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-017a872d"

export default script